import script from "./ScoringStandardManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoringStandardManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScoringStandardManagement.vue?vue&type=style&index=0&id=4024bb84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4024bb84"]])

export default __exports__